import CQ9FISHActions from './CQ9FISHActions'

export default class CQ9TABLEActions extends CQ9FISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'CQ9-TABLE-003',
      platform: 'CQ9',
    }

    this.gameName = 'Thai Pok Deng'
    this.roundIdPrefix = 'GO03m1'
    this.roundIdSuffix = 'm1m1'

    // bet / cancelBet
    // platformTxId: rel-rollout-GO03m1070374m2m1:cq9
    // roundId: GO03m1070374m2m1

    // settle / resettle
    // platformTxId: GO03m1070374m2m1
    // roundId: GO03m1070374m2m1
  }
}
